var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",value:({
	title:_vm.tooltip,
	interactive:false,
	animation:0,
	delay:0,
}),expression:"{\n\ttitle:tooltip,\n\tinteractive:false,\n\tanimation:0,\n\tdelay:0,\n}",modifiers:{"hover":true}}],staticClass:"d-button",on:{"click":_vm.download}},[_c('input',{ref:"input",domProps:{"value":_vm.value}})])}
var staticRenderFns = []

export { render, staticRenderFns }